export default __webpack_public_path__ + "static/media/YSSLogo01.d304a60a.png";